module.exports = __webpack_public_path__ + "img/product-shansuan-qzyy-01.4127b887.png";